import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FunctionalSubGroupEntry.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class FunctionalSubGroupEntry extends compose(_WidgetBaseSP) {
    templateString: any = template;

    isToDelete: boolean = false;

    fsg_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    fsg_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    fsg_Input_TextColor: HTMLInputElement;
    fsg_Input_BackgroundColor: HTMLInputElement;
    fsg_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    functionalSubGroupMainContainer: HTMLElement;
    functionalSubGroupHeader: HTMLElement;
    functionalSubGroupButtonEdit: HTMLButtonElement;
    functionalSubGroupButtonHide: HTMLButtonElement;
    functionalSubGroupButtonDelete: HTMLButtonElement;

    functionalSubGroupEditContainer: HTMLElement;

    formData: MainCatalogTypes.FunctionalSubGroup_SaveData = {
        ID: "",
        is_new_status: null,
        is_to_delete: null,
        code: "",
        description: null,
        order: null,
        coloration: null,
    };

    setEntry(isNew: boolean, entry?: MainCatalogTypes.FunctionalSubGroup_LoadData): void {

        if (isNew) {

            this.fillFormData();
            this.functionalSubGroupHeader.innerHTML = this.translations["MainCatalogsEditor_FunctionalSubGroup_NewEntryHeader"];
            this.UiModder.domClass.replace(this.functionalSubGroupMainContainer, "mds-bg-yellow", "mds-bg-green");
            this.UiModder.domClass.add(this.functionalSubGroupButtonEdit, "w3-hide");
            this.UiModder.domClass.remove(this.functionalSubGroupButtonHide, "w3-hide");
            this.UiModder.domClass.remove(this.functionalSubGroupEditContainer, "w3-hide");
        } else {

            this.fillFormData(entry);
            this.UiModder.domClass.remove(this.functionalSubGroupButtonEdit, "w3-hide");
        }
    }

    fillFormData(data?: MainCatalogTypes.FunctionalSubGroup_LoadData): void {

        if (data) {
            
            this.fsg_Input_Code.setValue(data.code, true);
            this.fsg_Input_Description.setValue(data.description_D, true);
            this.fsg_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.fsg_Input_BackgroundColor.value = data.coloration.BackColor.Hex;;
            this.fsg_Input_Order.setValue(data.order, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.fsg_Input_Code.setValue("", true);
            this.fsg_Input_Description.setValue("", true);
            this.fsg_Input_TextColor.value = "#000000";
            this.fsg_Input_BackgroundColor.value = "#ffffff";
            this.fsg_Input_Order.setValue(null, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.functionalSubGroupHeader.innerHTML = data ? data._displayname : "";
    }

    serializeFormData(): void {

        this.formData.code = this.fsg_Input_Code.getValue();
        this.formData.description = this.fsg_Input_Description.getValue();
        this.formData.order = this.fsg_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.fsg_Input_TextColor.value;
        let backHex = this.fsg_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        this.formData.is_to_delete = this.isToDelete;

        console.debug("SUB GROUP SERIALIZED DATA", this.formData);

        this.emit("FunctionalSubGroup_SerializeData");
    }

    _onChangeFunctionalSubGroupInputData(): void {

        this.serializeFormData();
        this.functionalSubGroupHeader.innerHTML = this.fsg_Input_Description.getValue();
    }

    _onClickButtonDelete(): void {

        this.isToDelete = !this.isToDelete;

        if (this.isToDelete) {

            if (this.formData.is_new_status === true) {

                this.emit("FunctionalSubGroup_Destroy");
                this.destroy();
                return;
            }

            this.UiModder.domClass.replace(this.functionalSubGroupMainContainer, "w3-pale-red", "mds-bg-green");
            this.functionalSubGroupButtonDelete.innerHTML = this.translations["GenericDialog__Btn_Cancel"];
        } else {

            this.UiModder.domClass.replace(this.functionalSubGroupMainContainer, "mds-bg-green", "w3-pale-red");
            this.functionalSubGroupButtonDelete.innerHTML = this.translations["General_Delete"];
        }

        this.serializeFormData();
    }

    _onClickButtonEdit(): void {

        this.UiModder.domClass.remove(this.functionalSubGroupEditContainer, "w3-hide");
        this.UiModder.domClass.add(this.functionalSubGroupButtonEdit, "w3-hide");
        this.UiModder.domClass.remove(this.functionalSubGroupButtonHide, "w3-hide");
    }

    _onClickButtonHide(): void {

        this.UiModder.domClass.add(this.functionalSubGroupEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.functionalSubGroupButtonEdit, "w3-hide");
        this.UiModder.domClass.add(this.functionalSubGroupButtonHide, "w3-hide");
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.fsg_Input_Code.setMaxLength(10);
        this.fsg_Input_Description.setMaxLength(255);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FunctionalSubGroupEntry.prototype, {
  fsg_Input_Code: () => (new Edit()),
  fsg_Input_Description: () => (new Edit()),
  fsg_Input_Order: () => (new NumberInput()),
});
export default mdsWidget(FunctionalSubGroupEntry);